import { createFileRoute } from "@tanstack/react-router";
import { AppManagement } from "@/components/AppManagement";

function RouteComponent() {
  return <AppManagement />;
}

export const Route = createFileRoute("/_authenticated/app-management/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
